import React from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';

import SVGIcon from 'lib/images/svg-pure-icon/svg-pure-icon';
import ImageView from 'lib/images/image-view';

import like from 'four-nets/icons/svg/icon_like-2.svg';
import comment from 'four-nets/icons/svg/icon_comment.svg';
import userIcon from 'four-nets/icons/svg/icon_user.svg';
import { displayedName } from 'four-nets/user/utils';

import { MasonryImageFragment } from './masonry-image.graphql';
import defaultStyles from './masonry-image.scss';
import TextShortener from 'four-nets/ui-v2/text-shortener/text-shortener';

export interface Props extends MasonryImageFragment {
    styles: typeof defaultStyles;
    imgRef: (element: HTMLImageElement | null, { id }: { id: number | string }) => void;
    onClick: (
        event: React.MouseEvent<HTMLDivElement | HTMLButtonElement | React.ReactNode>,
        { index }: { index: number }
    ) => void;
    index: number;
    disableLazyLoad?: boolean;
}

class MasonryImage extends React.PureComponent<Props, {}> {
    onClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        this.props.onClick(event, this.props);
    };

    onRef = (ref: HTMLImageElement | null) => {
        this.props.imgRef(ref, this.props);
    };

    render() {
        const { styles, photoFile, likesCount, commentCount, post, alt, disableLazyLoad } = this.props;

        return (
            <div className={styles.image} onClick={this.onClick}>
                <div className={styles.imageWrapper}>
                    <ImageView
                        src={(photoFile && photoFile.src) || ''}
                        srcSet={(photoFile && photoFile.srcset) || ''}
                        aspectFill={true}
                        forwardedRef={this.onRef}
                        sizes={{ xs: 200 }}
                        alt={alt}
                        disableLazyLoad={disableLazyLoad}
                    />
                    <div className={styles.stats}>
                        <div className={styles.statsRow}>
                            {likesCount ? (
                                <div className={styles.stat}>
                                    <SVGIcon src={like} className={styles.statIcon} />
                                    {likesCount || 0}
                                </div>
                            ) : null}
                            {commentCount ? (
                                <div className={styles.stat}>
                                    <SVGIcon src={comment} className={styles.statIcon} />
                                    {commentCount || 0}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                {post && post.href && post.title ? (
                    <Link to={post.href} className={styles.postTitle}>
                        <TextShortener text={post.title} textLength={35} />
                    </Link>
                ) : null}
                {post && post.user ? (
                    <Link
                        to={
                            (post.user &&
                                (post.user.profile.isVendor
                                    ? `/catalog/vendor/${post.user.username}`
                                    : `/blog/${post.user.username}`)) ||
                            ''
                        }
                        className={styles.user}
                    >
                        <SVGIcon src={userIcon} className={styles.icon} />
                        {post.user && displayedName(post.user)}
                    </Link>
                ) : null}
            </div>
        );
    }
}

export default Styled(defaultStyles)(MasonryImage);
